export const NEW_FUNNEL_KEY = 'new_funnel';

export const NEW_FUNNEL_BASE_PATH = '/social-media-finder';

export const FUNNEL_QUESTION_SEGMENT = 'q';

export const FUNNEL_SCREEN_SEGMENTS = {
  progress: 'progress',
  register: 'register',
  plan: 'plan',
} as const;

export type FunnelScreenSegment =
  (typeof FUNNEL_SCREEN_SEGMENTS)[keyof typeof FUNNEL_SCREEN_SEGMENTS];

export function buildFunnelQuestionPath(
  basePath: string,
  questionKey: string,
): string {
  return `${basePath}/${FUNNEL_QUESTION_SEGMENT}/${questionKey}`;
}

export function buildFunnelScreenPath(
  basePath: string,
  segment: FunnelScreenSegment,
): string {
  return `${basePath}/${segment}`;
}
